import { useCallback, useState } from "react";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import MDBox from "components/MDBox";
import { Success, Error_ } from "ui-components/Alert";
import { useCustomerValue } from "providers/CustomerContext";

import { getProofOfDelivery } from "services/data.outbound.service";
import CheckboxTable2 from "ui-components/tables/CheckboxTable2";
import { EditableDatePicker_ } from "ui-components/EditableInput2";
import { ListLayout } from "ui-components/Layout";
import { FormTitle } from "ui-components/Form";
import { InboundSubmitButton } from "ui-components/Form";
import { updateManifest } from "services/data.outbound.service";
import { LoadingDialog } from "ui-components/Alert";
import { TableCard } from "ui-components/Layout";
import MDButton from "components/MDButton";
import { LoadManifestDatePicker2 } from "ui-components/DatePicker";
import { useTeamValue } from "providers/TeamContext";

function ProofOfDelivery() {
  const {permissions, allowAll} = useTeamValue();
  const { customerCode } = useCustomerValue();
  const [data, setData] = useState([]);
  const [alert, setAlert] = useState(null);
  const queryClient = useQueryClient();
  const [filteredData, setFilteredData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  console.log(startDate);
  const addPermission = allowAll || (Boolean(permissions["Proof Of Delivery"]) && permissions["Proof Of Delivery"].findIndex(b => b==="new") !== -1);

  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const { isFetching } = useQuery({
    queryKey: ["pod-list", { customerCode }],
    queryFn: () => getProofOfDelivery({ customerCode }),
    enabled: Boolean(customerCode),
    onSuccess: (data) => setData(data.data.data),
    onError,
  });

  const columns = [
    {
      accessorKey: "manifestNumber",
      header: "Manifest Number",
      width: 150,
    },
    {
      accessorKey: "loadingDatetime",
      header: "Loading Datetime",
      width: 150,
    },
    {
      accessorKey: "carrier",
      header: "Carrier",
      width: 150,
    },
    {
      accessorKey: "doNumber",
      header: "DO Number",
      width: 150,
    },
    {
      accessorKey: "custOrdNbr",
      header: "Cust OrdNbr",
      width: 150,
    },

    {
      accessorKey: "podDate",
      header: "POD Date",
      width: 150,
      cell: EditableDatePicker_,
    },
  ];

  const updateManifestMutation = useMutation(updateManifest, {
    onSuccess: (data) => {
      queryClient.invalidateQueries(["pod-list"]);
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });
  const updateStatus=updateManifestMutation.status==="loading"

  const handleChange = useCallback((data) => {
    setFilteredData(data);
  }, []);

  const onSubmit = () => {
    const manifestDetails = data.filter((x) => x.podDate !== null);
    if (manifestDetails.length === 0) {
      setAlert(<Error_ content="Please update pod date" onChange={setAlert} />);
      return;
    }
    updateManifestMutation.mutate({ manifestDetails });
  };
  const onApply = () => {
    const filteredIds = filteredData.map((x) => x.id);
    console.log(filteredIds);

    console.log(filteredIds.includes(30));
    const updatedData = data.map((x) => {
      if (filteredIds.includes(x.id)) {
        x.podDate = startDate;
      }
      return x;
    });
    setData(updatedData);
  };

  return (
    <ListLayout>
      {(isFetching||updateStatus) && <LoadingDialog />}
      <MDBox mt={2}>
        {alert}
        <FormTitle title="Proof Of Delivery" />
      </MDBox>

      <TableCard>
        <MDBox display="flex" justifyContent="end" alignItems="flex-end" margin="10px">
          <LoadManifestDatePicker2 setStartDate={setStartDate} />
          <MDButton
            sx={{ ml: 1 }}
            color="info"
            variant="gradient"
            size="small"
            onClick={onApply}
            disabled={filteredData.length === 0}
          >
            apply all
          </MDButton>
        </MDBox>
        <CheckboxTable2
          data={data}
          columns={columns}
          setData={setData}
          onFilterRowsChange={handleChange}
        />
      </TableCard>

      {data.length > 0 && (
        <InboundSubmitButton label="Submit" onClick={onSubmit} disabled={data.length === 0 || !addPermission} />
      )}
    </ListLayout>
  );
}

export default ProofOfDelivery;
